import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as $sessionHttp from '@/auth/session-http';
import { Spinner } from '@/components/presentation/Spinner';
import { ProvideDefaultPathsContext } from '@/router/context';
import { actions } from '@/store/actions';

export const LogoutScreen = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const defaultPaths = useContext(ProvideDefaultPathsContext);

  const mutation = useMutation({
    mutationFn: () => {
      return $sessionHttp.logout();
    },
    onSuccess: (res, vars) => {
      Sentry.setUser(null);
      dispatch(actions.logout());
      queryClient.cancelQueries()
        .then(() => {
          queryClient.clear();
        });
    },
    onSettled: () => {
      // hack for now until refactor
      queryClient.refetchQueries(['get:app/theming']);
      navigate(defaultPaths.homePath, { replace: true });
    },
  });

  useEffect(() => {
    setTimeout(() => {
      mutation.mutateAsync();
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Root>
      <Spinner />
    </Root>
  );
};

const Root = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: `calc(100vh - var(--navbar-height))`,
});